import { mapGetters, mapState } from 'vuex';

import formatterMixin from './formatterMixin';

const settingMixin = {
  mixins: [formatterMixin],
  computed: {
    ...mapState({
      currentAdmin: (state) => state.admin.current,
      currentCorporation: (state) => state.setting.currentCorporation,
      partnerSettings: (state) => state.setting.partnerSettings,
      serviceCategoryList: (state) => state.setting.serviceCategoryList,
      puTableOptions: (state) => state.setting.puTableOptions,
      tuTableOptions: (state) => state.setting.tuTableOptions,
      puTableSearch: (state) => state.setting.puTableSearch,
      tuTableSearch: (state) => state.setting.tuTableSearch,
      loadingPlatformUsers: (state) => state.setting.loadingPlatformUsers,
      loadingTechnicians: (state) => state.setting.loadingTechnicians,
      currentUser: (state) => state.setting.currentUser,
      currentTechnician: (state) => state.setting.currentTechnician,
      partnerList: (state) => state.admin.partnerList,
      showActionModal: (state) => state.setting.showActionModal,
      actionModalView: (state) => state.setting.actionModalView,
      editing: (state) => state.setting.editing,
      loadingCurrentUser: (state) => state.setting.loadingCurrentUser,
      loadingCurrentCorporation: (state) => state.setting.loadingCurrentCorporation,
      taxExemptCategory: (state) => state.setting.taxExemptCategory,
      errorObj: (state) => state.setting.errorObj,
      partnerIndustry: (state) => state.setting.partnerIndustry,
      states: (state) => state.general.states,
      countries: (state) => state.general.countries,
      alertTypes: (state) => state.setting.alertTypes,
      showActiveUsers: (state) => state.setting.showActiveUsers,
      psmList: (state) => state.setting.psmList,
      parsingTechnician: (state) => state.setting.parsingTechnician,
      selectedCorp: (state) => state.setting.selectedCorp,
      warningDetailTab: (state) => state.setting.warningDetailTab,
      setupIntent: (state) => state.setting.setupIntent,
      selectedPaymentMethod: (state) => state.setting.selectedPaymentMethod,
      loadingPaymentMethod: (state) => state.setting.loadingPaymentMethod,
      processingDirectDebit: (state) => state.setting.processingDirectDebit,
      loadingInvoices: (state) => state.setting.loadingInvoices,
      loadingSubscriptions: (state) => state.setting.loadingInvoices,
      allProducts: (state) => state.general.allProducts,
      agreementBilling: (state) => state.setting.agreementBilling,
      agreements: (state) => state.setting.agreements,
      chargebeeCustomer: (state) => state.setting.chargebeeCustomer,
      recentInvoices: (state) => state.setting.recentInvoices,
      subscriptions: (state) => state.setting.subscriptions,
    }),
    ...mapGetters([
      'isSmacAdmin',
      'adminRole',
      'platformUsers',
      'allBranches',
    ]),
  },
  methods: {
    changeSettingValue(field, value) {
      this.$store.dispatch('changeSettingValue', {
        field,
        value,
      });
    },
    changeSettingValues(changes) {
      this.$store.dispatch('changeSettingValues', changes);
    },
    changeTableOptions(options, field, value) {
      this.$store.dispatch('changeTableOptions', {
        options,
        field,
        value,
      });
    },
    async toggleActionModal(show, view, item) {
      if (!show) {
        this.$store.dispatch('closeSettingActionModal');
      } else {
        const changes = [{
          field: 'showActionModal',
          value: show,
        }, {
          field: 'actionModalView',
          value: view,
        }];
        if (view === 'edit-technician' && item) {
          changes.push({
            field: 'currentTechnician',
            value: item,
          });
        } else if (view === 'edit-user' && item) {
          changes.push({
            field: 'currentUser',
            value: item,
          });
        } else if (view === 'warning-save' && item) {
          changes.push({
            field: 'warningDetailTab',
            value: item,
          });
        }
        this.$store.dispatch('changeSettingValues', changes);
      }
    },
  },
};

export default settingMixin;
